import highcharts from 'highcharts';
import $ from 'jquery';

class BalanceChartController {
  /* @ngInject */
  constructor($element, $filter, $log, $rootScope, NewUserInstrumentActions, NewUserInstrumentStore, NewTokenService, StoreStates) {
    const that = this;

    const PRIMARY_COLOR = '#236a95';
    const SECONDARY_COLOR = '#ff6c2c';

    that.loading = {
      instruments: false,
      balance: {
        card: false,
        wallet: false
      }
    };

    that.balance = {
      card: 0,
      wallet: 0
    };

    let chart;

    const drawChart = () => {
      chart = highcharts.chart($($element).find('.balance-chart')[0], {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          width: '220',
          height: '250'
        },
        tooltip: false,
        plotOptions: {
          pie: {
            states: {
              hover: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
            startAngle: 180,
            size: '100%',
            innerSize: '95%',
            borderWidth: 0,
            point: {
              events: {
                legendItemClick: (e) => {
                  e.preventDefault();
                }
              }
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: null
        },
        series: [{
          name: $filter('translate')('common.balance'),
          data: []
        }]
      });

      chart.showLoading();
    };

    const setChartData = () => {
      if (chart === undefined) {
        drawChart();
      }

      if (that.balance.wallet !== 0 || that.balance.card !== 0) {
        chart.series[0].setData([{
          name: $filter('translate')('common.instruments.bank'),
          color: PRIMARY_COLOR,
          y: parseFloat(that.balance.wallet)
        }, {
          name: $filter('translate')('common.instruments.card'),
          color: SECONDARY_COLOR,
          y: parseFloat(that.balance.card)
        }]);
      }

      if (!that.loading.balance.wallet && !that.loading.balance.card) {
        chart.hideLoading();
      }
    };

    const loadUserInstruments = () => {
      if (NewUserInstrumentStore.getUserInstrumentListState() === StoreStates.STORE_VALID) {
        that.loading.instruments = false;
        that.loading.balance.wallet = true;
        if (!NewUserInstrumentStore.isWalletBalancePending()) {
          NewUserInstrumentActions.getWalletBalance();
        }

        const card = NewUserInstrumentStore.getPrepaidCard();
        if (card && card.dtoPrepaidCard && card.dtoPrepaidCard.state !== 'PENDING') {
          that.loading.balance.card = true;
          that.card = card;
          if (!NewUserInstrumentStore.isPrepaidCardBalancePending()) {
            NewUserInstrumentActions.getPrepaidCardBalance();
          }
        }
      } else if (NewUserInstrumentStore.getUserInstrumentListState() !== StoreStates.STORE_PENDING_UPDATE) {
        that.loading.instruments = true;
        NewUserInstrumentActions.getUserInstrumentList();
      }
    };

    const init = () => {
      drawChart();
      loadUserInstruments();
    };

    const deregUserInstrumentUpdateListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE', loadUserInstruments);

    const deregUserInstrumentFailListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE_FAIL', () => {
      that.loading.instruments = false;
    });

    const deregWalletBalanceUpdateListener = $rootScope.$on('USERINSTRUMENT_WALLETBALANCE_UPDATE', () => {
      const balance = NewUserInstrumentStore.getLastWalletBalance();
      if (balance) {
        // that.balance.wallet = (balance / 100).toFixed(2);
        that.balance.wallet = parseFloat(balance);
      }

      that.loading.balance.wallet = false;
      setChartData();
    });

    const deregCardBalanceUpdateListener = $rootScope.$on('USERINSTRUMENT_CARDBALANCE_UPDATE', () => {
      const balance = NewUserInstrumentStore.getLastPrepaidCardBalance();
      if (balance) {
        // that.balance.card = (balance / 100).toFixed(2);
        that.balance.card = parseFloat(balance);
      }

      that.loading.balance.card = false;
      setChartData();
    });

    that.$postLink = init;

    that.$onDestroy = () => {
      deregUserInstrumentUpdateListener();
      deregUserInstrumentFailListener();
      deregWalletBalanceUpdateListener();
      deregCardBalanceUpdateListener();
    };
  }
}

export default BalanceChartController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/balanceChart/balanceChart.controller.js
 **/